import { FormControlLabel, Switch } from '@mui/material';

const CustomSwitch = ({ label, value, handleSwitchChange }) => {
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={value}
                    onChange={handleSwitchChange}
                    color="primary"
                    sx={{
                        transform: { xs: 'scale(0.8)', sm: 'scale(0.9)', md: 'scale(1)' },  // Responsive switch size
                        padding: { xs: 0.5, sm: 1 },  // Adjust padding
                        marginBottom: { xs: 1, sm: 2 }  // Consistent bottom spacing
                    }}
                />
            }
            label={label}
            labelPlacement="end"  // Ensures label is on the right and properly aligned
            sx={{
                margin: 0,  // Reset margin to avoid misalignment
                '& .MuiFormControlLabel-label': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },  // Responsive label font size
                    lineHeight: 1.5  // Aligns text vertically with the switch
                },
                display: 'flex',
                alignItems: 'center'  // Ensures vertical alignment
            }}
        />

    );
};

export default CustomSwitch;
